export default __webpack_public_path__ + "static/media/bgm.6378f67b.mp3";